import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from '../layouts/full/shared/loadable/Loadable';
import { useSelector } from 'react-redux';
import PrivateRouteError from 'src/views/apps/Error/PrivateRouteError';
import ArkchatUsersList from 'src/views/apps/ArkchatUser/ArkchatUsersList';

// ******************************************************

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

/* ****Dashboard***** */
const ModernDash = Loadable(lazy(() => import('../views/dashboard/Modern')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/login/Login')));
const SignIn = Loadable(lazy(() => import('../views/authentication/login/SignIn')));

const Verifyotp = Loadable(lazy(()=>import('../views/authentication/login/Verifyotp.js')));
// const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

// // Users
// const UserList = Loadable(lazy(() => import('../views/apps/users-list/UsersList')));
// const EditUserList = Loadable(lazy(() => import('../views/apps/users-list/EditUserList')));

// Subscriber
const Subscriber = Loadable(lazy(() => import('../views/apps/Subscriber/Subscriber')));
const SubscriberDetails = Loadable(lazy(() => import('../views/apps/Subscriber/SubscriberDetails')));
const SubscriberUserDetails = Loadable(lazy(() => import('../views/apps/Subscriber/SubscriberUserDetails')));
const SubscriberPostsList = Loadable(lazy(() => import('../views/apps/Subscriber/SubscriberPostsList')));


// Posts
 const Posts = Loadable(lazy(() => import('../views/apps/posts/Posts')));

// Billing
const BillingPlans = Loadable(lazy(() => import('../views/apps/billing/Plans')));

// // Products
// const Products = Loadable(lazy(() => import('../views/apps/Products/Products')));
// const EditProduct = Loadable(lazy(() => import('../views/apps/Products/EditProduct')));

// // Category
// const Category = Loadable(lazy(() => import('../views/apps/category/Category')));
// const EditCategory = Loadable(lazy(() => import('../views/apps/category/EditCategory')));

// // Roles&Permission
// const Roles = Loadable(lazy(() => import('../views/apps/rolesandpermission/Roles')));
// const Permission = Loadable(lazy(() => import('../views/apps/rolesandpermission/Permission')));
// const NewProductRequest = Loadable(
//   lazy(() => import('../views/apps/newProductRequest/NewProductRequest')),
// );

// // Master
// const Country = Loadable(lazy(() => import('../views/apps/Master/Country/Country')));
// const State = Loadable(lazy(() => import('../views/apps/Master/State/State')));
// const City = Loadable(lazy(() => import('../views/apps/Master/City/City')));

// // Unit
// const Unit = Loadable(lazy(() => import('../views/apps/Unit/Unit')));

// // Offers
// const Offers = Loadable(lazy(() => import('src/views/apps/Offers/Offers')));

// // Banner
// const BannerList = Loadable(lazy(() => import('src/views/apps/banner/BannerList')));

// // Setting
// const AppSetting = Loadable(lazy(() => import('src/views/apps/setting/appSetting/AppSetting')));
// const FaqSetting = Loadable(lazy(() => import('src/views/apps/setting/faqSetting/FaqSetting')));

const privateRoute = {
  path: '/',
  element: <FullLayout />,
  children: [
    { path: '/', element: <Navigate to="/dashboards/modern" /> },
    { path: '/dashboards/modern', exact: true, element: <ModernDash /> },

    // Users
    // { path: '/users-list', element: <UserList /> },
    // { path: '/users-list/edituser/:userId', element: <EditUserList /> },

    // Subscriber
    { path: '/subscribers', element: <Subscriber /> },
    { path: '/subscribers/details/:subscriberId', element: <SubscriberDetails /> },
    { path: '/subscribers/:userType-user-details/:subscriberId', element: <SubscriberUserDetails /> },
    { path: '/subscribers/:postType-posts-details/:subscriberId', element: <SubscriberPostsList /> },


    // Users
    {path:'/users-list',element:<ArkchatUsersList/>},
   

   // Posts
   { path: '/posts', element: <Posts /> },

   // Billing
   { path: '/billing/plans', element: <BillingPlans /> },


    // //Category
    // { path: '/category', element: <Category /> },
    // { path: '/category/edit-category/:categoryId', element: <EditCategory /> },

    // // Products
    // { path: '/products', element: <Products /> },
    // { path: '/products/edit-product/:productId', element: <EditProduct /> },

    // //Roles&Permission
    // { path: '/roles', element: <Roles /> },
    // { path: '/permissions', element: <Permission /> },
    // { path: '/product-requests', element: <NewProductRequest /> },
    // { path: '/country', element: <Country /> },
    // { path: '/state', element: <State /> },
    // { path: '/city', element: <City /> },
    // { path: '/unit', element: <Unit /> },
    // { path: '/offer', element: <Offers /> },

    // // Banner
    // { path: '/banner', element: <BannerList /> },

    // // Settings
    // { path: '/settings/app-setting', element: <AppSetting /> },
    // { path: '/settings/faq-setting', element: <FaqSetting /> },

    // Error page
    { path: '/auth/404', element: <PrivateRouteError /> },

    // *************************************
    { path: '*', element: <Navigate to="/auth/404" /> },
  ],
};

const publicRoute = {
  path: '/',
  element: <BlankLayout />,
  children: [
    { path: '/', element: <Navigate to="/auth/login" /> },
    // { path: '/auth/404', element: <Error /> },
    { path: '/auth/login', element: <Login /> },
    { path: '/auth/signin', element: <SignIn /> },
    { path: '/auth/verify-otp', element: <Verifyotp /> },

    { path: '/auth/maintenance', element: <Maintenance /> },
    { path: '*', element: <Navigate to="/auth/login" /> },
  ],
};

const Router = () => {
  const { token } = useSelector((state) => state.auth);
  // return [publicRoute,privateRoute]
  return token ? [privateRoute] : [publicRoute];
};

export default Router;
